export default __webpack_public_path__ + "static/web-site-middle-583f2b1a9be210776e3ba8316d7c97cd.jpg";